export default "__VITE_ASSET__Buulc_p6__"